import { queryKeys } from '@terminal/routes/query-params';
import {
  Suggestion,
  useRecentSearches,
} from '@terminal/views/news/hooks/use-recent-searches/useRecentSearches';
import { useNewsSearchStore } from '@terminal/views/news/stores/use-news-search-store/useNewsSearchStore';
import React from 'react';
import { useSearchParams } from 'react-router';

import { SearchSources } from '../search-sources/SearchSources';
import { SearchSuggestions } from '../search-suggestions/SearchSuggestions';
import mockSuggestions from './mock-suggestions.json';
import styles from './SearchLanding.module.scss';

export const SearchLanding = () => {
  const [, setSearchParams] = useSearchParams();

  const setSearchParam = (value: string) => {
    setSearchParams({
      [queryKeys.searchNews]: value,
    });
  };

  const setInputValue = useNewsSearchStore(state => state.setInputValue);
  const { recentSearches, addRecentSearch } = useRecentSearches();
  const suggestions = [...recentSearches, ...mockSuggestions] as Suggestion[];

  const handleSelect = (suggestion: Suggestion) => {
    setSearchParam(suggestion.label);
    addRecentSearch(suggestion.label);
    setInputValue(suggestion.label);
  };

  return (
    <div className={styles.searchLandingRoot} data-testid="search-landing">
      <div className={styles.content}>
        <SearchSources />
        <SearchSuggestions list={suggestions} handleSelect={handleSelect} />
      </div>
    </div>
  );
};
